<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <PageTitle title="Cashes" :rows="rows" />
        <CCardBody>
          <SubNav :csv_export="csv_export" />

          <div class="overflow-auto">
            <b-table
              id="my-table"
              :items="items"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              small
            >
              <template #cell(uname)="data">
                <td>
                  <CIcon
                    :name="
                      'cif-' + data.item.user_countryNameCode.toLowerCase()
                    "
                    width="40"
                  />
                  {{ data.item.uname }}
                </td>
              </template>
              <template #cell(attachAIDs)="data">
                <td
                  style="cursor: pointer"
                  @click="() => attachview(data.item)"
                >
                  <CIcon
                    name="cil-paperclip"
                    width="20"
                    v-show="data.item.attachAIDs != ''"
                  />
                </td>
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
              style="float: right"
            ></b-pagination>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
    <CModal
      :show.sync="visibleAttachView"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Attached Files"
      color="dark"
    >
      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="4000"
        controls
        indicators
        background="#ababab"
        img-width="200"
        img-height="200"
        style="text-shadow: 1px 1px 2px #333"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <!-- Text slides with image -->
        <b-carousel-slide
          :img-src="path"
          v-for="path in attachPaths"
          :key="path"
        ></b-carousel-slide>
      </b-carousel>
      <template #header>
        <h6 class="modal-title">Attached Files</h6>
        <CButtonClose @click="visibleAttachView = false" class="text-white" />
      </template>
      <template #footer>
        <div></div>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import firebase from "firebase";
import {
  timeConverter,
  from_0,
  to_24,
  getDateLabel,
} from "../../common-functions.js";
import * as Const from "../../const.js";
import PageTitle from "../component/PageTitle.vue";
import SubNav from "../component/SubNav.vue";
export default {
  name: "Cashes",
  components: { PageTitle, SubNav },
  data() {
    return {
      visibleAttachView: false,
      attachPaths: [],
      slide: 0,
      sliding: null,
      currentPage: 1,
      perPage: Const.perPage,
      items: [],

      fields: [
        {
          key: "entryDate",
          label: "Entry Date",
          _classes: "font-weight-bold",
          sortable: true,
        },

        { key: "uname", label: "User", sortable: true },

        {
          key: "amountGave",
          label: "Gave",
          _classes: "font-weight-bold",
          sortable: true,
        },
        {
          key: "amountGot",
          label: "Got",
          _classes: "font-weight-bold",
          sortable: true,
        },
        {
          key: "amountSumGave",
          label: "SumGave",
          _classes: "font-weight-bold",
          sortable: true,
        },
        {
          key: "amountSumGot",
          label: "SumGot",
          _classes: "font-weight-bold",
          sortable: true,
        },
        { key: "attachAIDs", label: "Attach" },
        { key: "detail", label: "Detail", sortable: true },
        { key: "createdAt", label: "Created At", sortable: true },
        { key: "updatedAt", label: "updated At", sortable: true },
      ],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
    need_refresh() {
      return (
        this.$store.state.selcountryCode +
        (this.$store.state.showSubNav.user
          ? "-" + this.$store.state.seluid
          : "") +
        (this.$store.state.showSubNav.business
          ? "-" + this.$store.state.selbid
          : "") +
        (this.$store.state.showSubNav.customer
          ? "-" + this.$store.state.selcid
          : "") +
        (this.$store.state.showSubNav.date
          ? "-" + getDateLabel(this.$store.state.from, this.$store.state.to)
          : "")
      );
    },
  },
  watch: {
    need_refresh: {
      immediate: true,
      handler(value) {
        this.load("data");
      },
    },
  },
  created() {
    this.$store.commit("set", [
      "showSubNav",
      { user: true, business: false, customer: false, date: true },
    ]);
  },
  methods: {
    load(type) {
      const db = firebase.firestore();
      if (type == "data") {
        //if (this.seluid == "") return;

        let ref = db.collection("cash_entry");
        if (this.$store.state.seluid != "")
          ref = ref.where("uid", "==", this.$store.state.seluid);
        ref = ref.where("isDeleted", "==", false);
        if (this.$store.state.from != "")
          ref = ref.where("entryDate", ">=", from_0(this.$store.state.from));
        if (this.$store.state.to != "")
          ref = ref.where("entryDate", "<=", to_24(this.$store.state.to));

        if (this.$store.state.selcountryCode != "") {
          ref = ref.where(
            "userCountryNameCode",
            "==",
            this.$store.state.selcountryCode
          );
        }
        this.$store.commit("set", ["loading_data", true]);
        try {
          ref
            .orderBy("entryDate", "desc")
            .get()
            .then((querySnapshot) => {
              this.items = [];
              this.page = 0;

              querySnapshot.forEach((doc) => {
                // console.log(doc.data());
                var entry = {
                  entryDate: timeConverter(doc.data().entryDate.seconds),
                  eid: doc.id,
                  uid: doc.data().uid,

                  attachAIDs:
                    (doc.data().photos && doc.data().photos.length > 0) ||
                    (doc.data().attachAIDs && doc.data().attachAIDs.length > 0)
                      ? doc.id
                      : "",

                  detail: doc.data().detail,
                  uname: doc.data().userPhoneNumber,
                  phoneNumber: "",

                  user_countryNameCode: doc.data().userCountryNameCode,
                  amountGave: doc.data().amountGave,
                  amountGot: doc.data().amountGot,
                  amountSumGave: doc.data().amountSumGave,
                  amountSumGot: doc.data().amountSumGot,
                  createdAt: timeConverter(doc.data().createdAt.seconds),
                  updatedAt: timeConverter(doc.data().updatedAt.seconds),
                };

                this.items.push(entry);
              });
              this.$store.commit("set", ["loading_data", false]);
            });
        } catch (e) {
          this.$store.commit("set", ["loading_data", false]);
        } finally {
        }
      }
    },

    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },

    csv_export() {
      let csvContent = "";

      var universalBOM = "\uFEFF";

      this.fields.forEach(function (row) {
        csvContent += row.label + ",";
      });
      csvContent += "\r\n";
      this.items.forEach(function (row) {
        var row_str = "";

        row_str += '"' + row.entryDate + ' ",';
        row_str += '"' + row.uname + '",';
        row_str += '"' + row.amountGave + '",';
        row_str += '"' + row.amountGot + '",';
        row_str += '"' + row.amountSumGave + '",';
        row_str += '"' + row.amountSumGot + '",';
        row_str += '"' + "" + '",';
        row_str += '"' + row.detail + '",';
        row_str += '"' + row.createdAt + '",';
        row_str += '"' + row.updatedAt + '",';

        csvContent += row_str + "\r\n";
      });
      var universalBOM = "\uFEFF";
      var a = window.document.createElement("a");
      a.setAttribute(
        "href",
        "data:text/csv; charset=utf-8," +
          encodeURIComponent(universalBOM + csvContent)
      );
      a.setAttribute("download", "customers" + this.need_refresh + ".csv");
      window.document.body.appendChild(a);
      a.click();
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    attachview(item) {
      var db = firebase.firestore();

      db.collection("attach")
        .where("uid", "==", item.uid)
        .where("eid", "==", item.eid)
        .get()
        .then((querySnapshot) => {
          // console.log(querySnapshot);
          this.attachPaths = [];
          querySnapshot.forEach((doc) => {
            if (doc.exists) {
              this.attachPaths.push(doc.data().storeURL);
            } else {
              console.log("No such Business document!");
            }
          });
          this.visibleAttachView = true;
        })
        .catch((error) => {
          console.log("Error getting document 3:", error);
        });
    },
  },
};
</script>
